import { Legale } from '../../../models/legale';


export class LegaleAdapter {
    legale: Legale = new Legale();

constructor(legale: Legale) {
    this.legale.id = legale.id;
    this.legale.nome = legale.nome;
    this.legale.cognome = legale.cognome;
    this.legale.codiceFiscale = legale.codiceFiscale;
    this.legale.dataNascita = legale.dataNascita;
    this.legale.comuneNascita = legale.comuneNascita ?  JSON.parse(JSON.stringify(legale.comuneNascita)) : null;
    this.legale.provinciaNascita = legale.provinciaNascita ? JSON.parse(JSON.stringify(legale.provinciaNascita)) : null;
    this.legale.matricola = legale.matricola;
    this.legale.telefono = legale.telefono;
    this.legale.cellulare = legale.cellulare;
    this.legale.email = legale.email;
    this.legale.fax = legale.fax;
    this.legale.pec = legale.pec;
    this.legale.indirizzo = legale.indirizzo;
    this.legale.cap = legale.cap;
    this.legale.comuneResidenza = legale.comuneResidenza ? JSON.parse(JSON.stringify(legale.comuneResidenza)) : null;
    this.legale.provinciaResidenza = legale.provinciaResidenza ? JSON.parse(JSON.stringify(legale.provinciaResidenza)) : null;
    this.legale.partitaIva = legale.partitaIva;
    this.legale.codiceFiscaleRappresentanteLegale = legale.codiceFiscaleRappresentanteLegale;
    this.legale.ragioneSociale = legale.ragioneSociale;
    this.legale.dipendente = legale.dipendente; // legale.dipendente ? JSON.parse(JSON.stringify(legale.dipendente)) : false;
    this.legale.tipoPersona = legale.tipoPersona ? JSON.parse(JSON.stringify(legale.tipoPersona)) : null;
    this.legale.tipoSocieta = legale.tipoSocieta ? JSON.parse(JSON.stringify(legale.tipoSocieta)) : null;
    this.legale.note = legale.note;
    this.legale.rimosso = legale.rimosso ? JSON.parse(JSON.stringify(legale.rimosso)) : false;
    this.legale.ambitiCompetenza = legale.ambitiCompetenza ? JSON.parse(JSON.stringify(legale.ambitiCompetenza)) : [];
    this.legale.tariffa = legale.tariffa;
    this.legale.tariffe = legale.tariffe;
    this.legale.convenzione = legale.convenzione ? legale.convenzione : false;
    this.legale.sesso= legale.sesso;
};
}
